module.exports = __webpack_public_path__ + "img/logo-mini.b281ad3e.svg";